import React from 'react'
import Card from 'react-bootstrap/Card'
import { ImPointRight } from 'react-icons/im'

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: 'justify' }}>
            Hi everyone! I’m <span className="purple">Martin Mounir</span> from{' '}
            <span className="purple">Egypt</span>.
            <br />
            I’m currently a{' '}
            <span className="purple">Computer Science Student</span> at{' '}
            <span className="purple">October 6 University</span>.
            <br />
            I’m also a passionate{' '}
            <span className="purple">Front-End Developer</span> who loves
            building modern and responsive web applications.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and continuously improving:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Listening to Music & Playing Guitar 🎸
            </li>
            <li className="about-activity">
              <ImPointRight /> Practicing Sports like Football & Gym Training
              ⚽🏋️
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: 'rgb(155 126 172) ' }}>
            "WHATEVER YOU WANT, YOU CAN ACHIEVE — JUST BELIEVE IN YOURSELF."
          </p>
          <footer className="blockquote-footer">Martin</footer>
        </blockquote>
      </Card.Body>
    </Card>
  )
}

export default AboutCard
